import { QueryParamsEnum } from '@honeycomb/data';
import { QueryParamManager } from '../utils/QueryParamManager';
import { router } from '../utils/router';
export function searchErrorRoute({ code, messages }) {
    const paramManager = new QueryParamManager('/invalid-search', router.currentParams());
    if (code)
        paramManager.add(QueryParamsEnum.ERROR_CODE, code);
    if (messages)
        messages.forEach((message) => paramManager.add(QueryParamsEnum.ERROR_MESSAGE, message));
    return [paramManager.toString(), undefined, { shallow: true }];
}
export function searchErrorRouting({ code, messages }) {
    router.push(null, () => searchErrorRoute({ code, messages }));
}
